import { httpRequest } from '@/shared/lib/http';

export interface RegisterPaymentDto {
  invoiceId: string;
  amount: number;
  paymentMethod: string;
  reference: string;
  notes?: string;
  currency?: string;
}

export interface CreatePurchaseOrderRequest {
  deliveryDate: string;
  deliveryAddress: string;
  notes?: string;
  supplierId: string;
  lines: Array<{
    productCode: string;
    productName: string;
    description?: string;
    quantity: number;
    unitOfMeasure?: string;
    unitPrice: number;
    discountPercent?: number;
    taxPercent?: number;
  }>;
}

export interface CreatePurchaseOrderResponse {
  id: string;
  supplier: {
    id: string;
    company_name: string;
    rfc: string;
  } | null;
  po_number: string;
  status: string;
  subtotal: number;
  tax: number;
  total: number;
  currency: string;
  delivery_date: string;
  delivery_address: string;
  notes?: string;
  cost_center?: string;
  lines: Array<{
    id: string;
    line_number: number;
    product_code: string;
    product_name: string;
    description?: string;
    quantity: number;
    unit_of_measure: string;
    unit_price: number;
    discount_percent: number;
    tax_percent: number;
    subtotal: number;
    tax_amount: number;
    total: number;
  }>;
  created_at: string;
  updated_at: string;
}

export const adminPurchaseOrdersService = {
  async createPurchaseOrder(
    data: CreatePurchaseOrderRequest,
  ): Promise<CreatePurchaseOrderResponse> {
    return (await httpRequest<CreatePurchaseOrderResponse>(
      '/admin/purchase-orders',
      { method: 'POST', body: JSON.stringify(data) },
    )) as CreatePurchaseOrderResponse;
  },

  async getSuppliers(page = 1, limit = 100) {
    return await httpRequest(`/admin/suppliers?page=${page}&limit=${limit}`);
  },

  async assignSupplier(orderId: string, supplierId: string) {
    return await httpRequest(`/admin/purchase-orders/${orderId}`, {
      method: 'PUT',
      body: JSON.stringify({ supplierId }),
    });
  },

  async getAllInvoices() {
    return await httpRequest('/admin/purchase-orders/all-invoices');
  },

  /** Descarga el Excel del listado de Pagos respetando los filtros activos. */
  async exportPagos(filters: {
    estado?: string;
    proveedor?: string;
    fechaDesde?: string;
    fechaHasta?: string;
    search?: string;
  }): Promise<Blob> {
    const params = new URLSearchParams();
    for (const [clave, valor] of Object.entries(filters)) {
      if (valor) params.append(clave, valor);
    }
    const query = params.toString();
    return (await httpRequest<Blob>(
      `/admin/purchase-orders/pagos/export${query ? `?${query}` : ''}`,
      { comoBlob: true },
    )) as Blob;
  },

  async registerPayment(poId: string, data: RegisterPaymentDto): Promise<void> {
    await httpRequest(`/admin/purchase-orders/${poId}/payments`, {
      method: 'POST',
      body: JSON.stringify({
        invoiceId: data.invoiceId,
        amount: data.amount,
        currency: data.currency || 'MXN',
        paymentMethod: data.paymentMethod,
        reference: data.reference,
        paymentDate: new Date(),
        notes: data.notes,
      }),
    });
  },
};
